/**
 * Created by qlong on 9/9/2016.
 */
import { combineReducers } from 'redux'
import filters from './filterReducer'
import fileData from './fileDataReducer'
import filterGrid from './filterGridReducer'
import filteredLineChart from './filteredLineChartReducer'

export default combineReducers({
    filters,
    fileData,
    filterGrid,
    filteredLineChart,
})


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/